import { CardStack } from './card-stack';
import { Type } from '@angular/core';
import { PrintCardContentComponent } from '../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { CardBackgroundComponent } from '../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PaperSize } from '../../../shared/paper-size';
import { Orientation } from '../../../enum/dto/orientation.enum';
import type { CardData } from '../../../print-cards/card-data';

export class EmptyCardStack extends CardStack {
  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return null;
  }

  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return null;
  }

  getCardWidthInInches(): number {
    return 0;
  }

  getCardHeightInInches(): number {
    return 0;
  }

  nRows(): number {
    return 0;
  }

  nColumns(): number {
    return 0;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 0;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return null;
  }
}
